export const getMobileMaxColumnWidth = (minimumColumnCount) => {
    if (typeof window === 'undefined') {
        return 100
    }

    return Math.floor(window.innerWidth / minimumColumnCount)
}

export const adaptiveFontSize =
    (bounds: any = {}) =>
    (data) => {
        const {
            parent: { fontSizeMinimum = 0 },
            gridPadding,
            columnWidth,
            // config,
            chain,
        } = data
        const {
            upperBound = Infinity,
            lowerBound = fontSizeMinimum,
            fixed,
        } = bounds

        const [parentOfParent] = chain
        const {
            column: { maxWidth },
        } = parentOfParent
        const minWidth = fixed ? columnWidth : maxWidth

        const ratio = fontSizeMinimum / minWidth
        const rounded =
            Math.round(ratio * (columnWidth - gridPadding) * 10) / 10
        const result = Math.min(Math.max(rounded, lowerBound), upperBound)

        return result
    }
